import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ServiceStatsItem } from '@/api/dashboardApi';

interface ServiceStatsChartProps {
  services: ServiceStatsItem[];
}

export const ServiceStatsChart: React.FC<ServiceStatsChartProps> = ({ services }) => {
  // Recharts 형식으로 데이터 변환
  const chartData = services.map(service => ({
    name: service.serviceName,
    완료: service.completedCount,
    대기중: service.pendingCount,
    실패: service.failedCount,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>서비스별 처리량</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="완료" fill="#10b981" />
            <Bar dataKey="대기중" fill="#f59e0b" />
            <Bar dataKey="실패" fill="#ef4444" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
